export default function (val) {
  if (!val) return ''
  val = val.toString()
  return val.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
}
